import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@/lib/queryClient";
import type { EntraSyncStatusResponse } from "@/types/generated/cms.generated";

/**
 * Microsoft Entra sync status for an organisation. `isEnabled` is the single source of truth for
 * "this organisation signs in with Microsoft Entra" (it replaces the never-returned
 * `hasEntraIntegration` organisation field). CMS API `GET /organizations/{organizationId}/entra-sync-status`.
 */
/** Overview row text: "Unknown" until the status has loaded (never a false "Disabled"). */
export function entraIntegrationLabel(query: {
  data: Pick<EntraSyncStatusResponse, "isEnabled"> | undefined;
  isLoading: boolean;
  isError: boolean;
}): "Enabled" | "Disabled" | "Unknown" {
  if (query.isError || query.isLoading || !query.data) return "Unknown";
  return query.data.isEnabled ? "Enabled" : "Disabled";
}

export function useOrgEntraSyncStatus(organizationId: string | null | undefined) {
  return useQuery<EntraSyncStatusResponse>({
    queryKey: ["organizations", organizationId, "entra-sync-status"],
    queryFn: () =>
      apiRequest<EntraSyncStatusResponse>("GET", `/organizations/${organizationId}/entra-sync-status`),
    enabled: !!organizationId,
  });
}
